"use client";
import React, { useMemo } from "react";
import AccordionGroup from "@/components/Accordion/AccordionGroup";
import Breadcrumb from "@/components/Breadcrumbs/Breadcrumb";
import menu from "@/data/menu.json";
import others from "@/data/docs.json";
import { v4 as uuidv4 } from "uuid";
import { FaFile } from "react-icons/fa";

const Requisitos = () => {
  function mapToAccordionData(data) {
    const buildNode = (node) => {
      const id = uuidv4();
      const contentElements = [];

      if (Array.isArray(node.docs)) {
        node.docs.forEach((doc) => {
          contentElements.push(
            <a
              key={uuidv4()}
              href={doc.path}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 rounded bg-slate-100 p-2 text-sm hover:bg-slate-200"
            >
              <FaFile className="text-primary" />
              <span>{doc.name}</span>
            </a>,
          );
        });
      } else if (node.docs && typeof node.docs === "object") {
        contentElements.push(
          <a
            key={uuidv4()}
            href={node.docs.path}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 rounded bg-slate-100 p-2 text-sm hover:bg-slate-200"
          >
            <FaFile className="text-primary" />
            <span>{node.docs.name}</span>
          </a>,
        );
      }

      if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
          if (Array.isArray(child.docs)) {
            child.docs.forEach((doc) => {
              contentElements.push(
                <a
                  key={uuidv4()}
                  href={doc.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 rounded bg-slate-100 p-2 text-sm hover:bg-slate-200"
                >
                  <FaFile className="text-primary" />
                  <span>{doc.name}</span>
                </a>,
              );
            });
          } else if (child.docs && typeof child.docs === "object") {
            contentElements.push(
              <a
                key={uuidv4()}
                href={child.docs.path}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 rounded bg-slate-100 p-2 text-sm hover:bg-slate-200"
              >
                <FaFile className="text-primary" />
                <span>{child.docs.name}</span>
              </a>,
            );
          }
        });
      }

      return {
        id,
        title: node.name,
        content:
          contentElements.length > 0 ? (
            <div className="space-y-2">{contentElements}</div>
          ) : null,
      };
    };

    return data.map(buildNode);
  }

  const docs = useMemo(() => {
    let viewData = [];

    if (menu.length > 0) {
      const menuExclude = ["Tutoriales", "Requisitos"];
      const tempMenu = menu.filter((item) => !menuExclude.includes(item.name));
      viewData = mapToAccordionData(tempMenu);
    }

    if (others.length > 0) {
      viewData = [...viewData, ...mapToAccordionData(others)].sort((a, b) =>
        a.title.localeCompare(b.title),
      );
    }

    return viewData;
  }, []);

  return (
    <>
      <Breadcrumb pageName="Requisitos de trámites y solicitudes municipales" />
      <div className="flex flex-col overflow-x-auto">
        <AccordionGroup items={docs} searchable={true} exclusive={false} />
      </div>
    </>
  );
};

export default Requisitos;